import { Grid, MenuItem, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppLoader from "../../../components/AppLoader";
import PaperContainer from "../../../components/Containers/PaperContainer";
import NotificationCard from "../../../components/NotificationsCard";
import useNotifications from "../../../hooks/useNotifications";
import { useTranslation } from "react-i18next";
import CustomSelect from "./../../../components/customSelect/index";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { setNotificationRelatedTo } from "../../../lib/slices/searchKeysSlice";

const allNotificationRelatedTo = [
  {
    label: "notificationRelatedToOrder",
    value: "order",
  },
  {
    label: "notificationRelatedToAppointment",
    value: "appointment",
  },
  {
    label: "notificationRelatedToRegistration",
    value: "registration",
  },
];

const MyNotifications = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["notification"]);
  const userData = useSelector((state) => state.userData.user);
  const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);
  const { notificationsLoading, allNotifications, fetchAllNotifications } =
    useNotifications();

  useEffect(() => {
    if (userData) {
      fetchAllNotifications(searchKeys.notificationRelatedTo);
    }
  }, [userData, searchKeys.notificationRelatedTo]);

  const renderSearchAction = () => {
    return (
      <Stack
        gap={{ xs: 2, md: 1 }}
        p={2}
        direction={{ md: "row" }}
        bgcolor={"primary.light"}
        alignItems={"center"}
      >
        <CustomSelect
          formStyleProps={{
            width: { xs: "100%", md: "25%" },
            "& .MuiInputBase-input": {
              textTransform: "capitalize",
            },
          }}
          icon={
            <NotificationsIcon sx={{ fontSize: "15px", color: "#000000" }} />
          }
          value={searchKeys.notificationRelatedTo}
          onChange={(e) => {
            dispatch(setNotificationRelatedTo(e.target.value));
          }}
        >
          <MenuItem value={"All"}>{t("allNotifications")}</MenuItem>
          {allNotificationRelatedTo.map((val, ind) => {
            return (
              <MenuItem
                key={ind}
                value={val.value}
                sx={{ textTransform: "capitalize" }}
              >
                {t(val.label)}
              </MenuItem>
            );
          })}
        </CustomSelect>
      </Stack>
    );
  };

  return (
    <>
      <AppLoader isVisible={notificationsLoading} />
      <PaperContainer
        title={t("myNotifications")}
        subtitle={t("viewYourNotifications")}
        searchActions={renderSearchAction()}
      >
        <Grid container spacing={2} alignItems="stretch">
          {allNotifications.map((val, index) => {
            return (
              <Grid
                key={index}
                item
                xs={12}
                sm={6}
                md={4}
                style={{ display: "flex" }}
              >
                <NotificationCard data={val} index={index} />
              </Grid>
            );
          })}
        </Grid>
      </PaperContainer>
    </>
  );
};

export default MyNotifications;
